<template>
  <div>
    <hr />
    <div class="mb-3">
      <table class="tablaBusqueda">
        <tbody>
          <tr>
            <td>
              <button
                type="submit"
                class="btn btn-light"
                data-bs-toggle="modal"
                data-bs-target="#ventanaModal"
                @click="abrirModalCrear"
                :disabled="p_estadoFactura != 'E'"
                title="Nuevo registro"
              >
                <i
                  class="material-icons"
                  style="font-size: 24px; color: green; cursor: pointer"
                  >add_box</i
                >
                Registrar Pago
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <table class="table" id="sampleTable">
      <thead>
        <tr>
          <th scope="col"></th>
          <th scope="col">Fecha Pago</th>
          <th scope="col">Forma de Pago</th>
          <th scope="col">Asegurador</th>
          <th scope="col">EstadoPago</th>
          <th scope="col" style="text-align: right">Monto</th>
          <th scope="col">Referencia</th>
          <th scope="col"></th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="pago in datosPaginados" :key="pago.idPago">
          <td>
            <i
              class="material-icons"
              style="font-size: 16px; color: orangered; cursor: pointer"
              @click="p_estadoFactura !== 'E' && abrirModalEditar(pago.idPago)"
              title="Editar"
              >edit_square</i
            >
          </td>
          <td>{{ getFormattedDate(pago.fechaPago, "DD/MM/YYYY") }}</td>
          <td>{{ pago.formaPagoNombre }}</td>
          <td>{{ pago.aseguradorNombre }}</td>
          <td>{{ pago.estadoPago }}</td>
          <td style="text-align: right">{{ pago.monto }}</td>
          <td>{{ pago.referencia }}</td>
          <td>
            <i
              class="material-icons"
              style="font-size: 16px; color: red; cursor: pointer"
              @click="deletePago(pago.idPago)"
              title="Borrar"
              >delete</i
            >
          </td>
        </tr>
      </tbody>
      <tfoot>
        <tr>
          <th colspan="5" style="text-align: right">TOTAL:</th>
          <th style="text-align: right">{{ totalPagos }}</th>
          <th colspan="2" scope="col"></th>
        </tr>
      </tfoot>
    </table>
    <nav aria-label="Page navigation example">
      <ul class="pagination">
        <li class="page-item" v-on:click="getPreviousPage()">
          <a class="page-link" href="#">Anterior</a>
        </li>
        <li
          id="lugar"
          v-for="pagina in totalPaginas()"
          v-bind:key="pagina"
          v-on:click="getDataPaginaTodos(pagina)"
          class="page-item"
          v-bind:class="isActive(pagina)"
        >
          <a class="page-link" href="#">{{ pagina }}</a>
        </li>
        <li class="page-item" v-on:click="getNextPage()">
          <a class="page-link" href="#">Siguiente</a>
        </li>
      </ul>
    </nav>
    <!-- Modal -->
    <div
      class="modal fade"
      id="ventanaModal"
      tabindex="-1"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
      v-if="modalWindow"
    >
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-header bg-primary">
            <h5 class="modal-title" id="exampleModalLabel">
              <i class="fa fa-user-plus"></i> {{ titulo }}
            </h5>
            <button
              type="button"
              class="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>
          <form>
            <div class="modal-body">
              <div class="mb-3">
                <div class="row">
                  <div class="col-2">
                    <label for="idFormaPago" class="form-label">
                      Forma Pago</label
                    >
                  </div>
                  <div class="col-10">
                    <select
                      class="form-control"
                      id="idFormaPago"
                      name="idFormaPago"
                      v-model="datoPago.idFormaPago"
                    >
                      <option
                        v-for="formaPago in formaPagos"
                        :value="formaPago.idFormaPago"
                        :key="formaPago.idFormaPago"
                      >
                        {{ formaPago.nombre }}
                      </option>
                    </select>
                  </div>
                </div>
              </div>
              <div class="mb-3" v-if="datoPago.idFormaPago == 5">
                <div class="row">
                  <div class="col-2">
                    <label for="idAsegurador" class="form-label"
                      >Asegurador</label
                    >
                  </div>
                  <div class="col-10">
                    <select
                      class="form-control"
                      id="idAsegurador"
                      name="idAsegurador"
                      v-model="datoPago.idAsegurador"
                    >
                      <option
                        v-for="asegurador in aseguradors"
                        :value="asegurador.idAsegurador"
                        :key="asegurador.idAsegurador"
                      >
                        {{ asegurador.nombre }}
                      </option>
                    </select>
                  </div>
                </div>
              </div>
              <!-- Botón Lista de Valores  Forma Pago -->
              <div class="mb-3">
                <div class="row">
                  <div class="col-2">
                    <label for="fechaPago" class="form-label">FechaPago</label>
                  </div>
                  <div class="col-10">
                    <input
                      type="date"
                      class="form-control"
                      id="fechaPago"
                      name="fechaPago"
                      v-model="datoPago.fechaPago"
                      required
                    />
                  </div>
                </div>
              </div>
              <div class="mb-3" v-if="btnEditar">
                <div class="row">
                  <div class="col-2">
                    <label for="estadoPago" class="form-label"
                      >EstadoPago</label
                    >
                  </div>
                  <div class="col-10">
                    <input
                      type="text"
                      class="form-control"
                      id="estadoPago"
                      name="estadoPago"
                      v-model="datoPago.estadoPago"
                      style="text-transform: uppercase"
                      required
                    />
                  </div>
                </div>
              </div>
              <div class="mb-3">
                <div class="row">
                  <div class="col-2">
                    <label for="monto" class="form-label">Monto</label>
                  </div>
                  <div class="col-10">
                    <input
                      type="number"
                      class="form-control"
                      id="monto"
                      name="monto"
                      v-model="datoPago.monto"
                      min="0"
                      required
                    />
                  </div>
                </div>
              </div>
              <div class="mb-3">
                <div class="row">
                  <div class="col-2">
                    <label for="referencia" class="form-label"
                      >Referencia</label
                    >
                  </div>
                  <div class="col-10">
                    <input
                      type="text"
                      class="form-control"
                      id="referencia"
                      name="referencia"
                      v-model="datoPago.referencia"
                      style="text-transform: uppercase"
                      required
                    />
                  </div>
                </div>
              </div>
              <button @click.prevent="mostrarOcultarBloque">
                {{
                  mostrarBloque
                    ? "(-) Menos información"
                    : "(+) Más información"
                }}
              </button>
              <div v-if="mostrarBloque" class="mb-3">
                <div class="mb-3" v-if="btnEditar">
                  <div class="row">
                    <div class="col-2">
                      <label for="idPago" class="form-label">IdPago</label>
                    </div>
                    <div class="col-10">
                      <input
                        type="text"
                        class="form-control"
                        id="idPago"
                        name="idPago"
                        v-model="datoPago.idPago"
                        disabled
                      />
                    </div>
                  </div>
                </div>
                <!-- Botón Lista de Valores  Factura -->
                <div class="mb-3">
                  <div class="row">
                    <div class="col-2">
                      <label for="idFactura" class="form-label"> Factura</label>
                    </div>
                    <div class="col-10">
                      <select
                        class="form-control"
                        id="idFactura"
                        name="idFactura"
                        v-model="datoPago.idFactura"
                      >
                        <option
                          v-for="factura in facturas"
                          :value="factura.idFactura"
                          :key="factura.idFactura"
                        >
                          {{ factura.nombre }}
                        </option>
                      </select>
                    </div>
                  </div>
                </div>
                <!-- Botón Lista de Valores  Factura -->
                <div class="mb-3">
                  <div class="row">
                    <div class="col-2">
                      <label for="idUsuarioReg" class="form-label"
                        >IdUsuarioReg</label
                      >
                    </div>
                    <div class="col-10">
                      <input
                        type="text"
                        class="form-control"
                        id="idUsuarioReg"
                        name="idUsuarioReg"
                        v-model="datoPago.idUsuarioReg"
                        style="text-transform: uppercase"
                        required
                      />
                    </div>
                  </div>
                </div>
                <div class="mb-3">
                  <div class="row">
                    <div class="col-2">
                      <label for="idUsuarioAct" class="form-label"
                        >IdUsuarioAct</label
                      >
                    </div>
                    <div class="col-10">
                      <input
                        type="text"
                        class="form-control"
                        id="idUsuarioAct"
                        name="idUsuarioAct"
                        v-model="datoPago.idUsuarioAct"
                        style="text-transform: uppercase"
                        required
                      />
                    </div>
                  </div>
                </div>
                <!-- Botón Lista de Valores  Forma Pago -->
                <div class="mb-3">
                  <div class="row">
                    <div class="col-2">
                      <label for="fechaReg" class="form-label"
                        >Fecha de registro</label
                      >
                    </div>
                    <div class="col-10">
                      <input
                        type="text"
                        class="form-control"
                        id="fechaReg"
                        name="fechaReg"
                        v-model="datoPago.fechaReg"
                        disabled
                      />
                    </div>
                  </div>
                </div>
                <div class="mb-3">
                  <div class="row">
                    <div class="col-2">
                      <label for="fechaAct" class="form-label">FechaAct</label>
                    </div>
                    <div class="col-10">
                      <input
                        type="date"
                        class="form-control"
                        id="fechaAct"
                        name="fechaAct"
                        v-model="datoPago.fechaAct"
                        required
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </form>
          <div class="modal-footer">
            <!--
        <div class="me-auto">
          <button type="button" id="send" class="btn btn-light" data-bs-dismiss="modal" title="Cerrar">
            <i class="material-icons" style="font-size:32px;color:orangered; cursor: pointer;">meeting_room</i>
          </button>
        </div>
-->
            <p class="texto-rojo-negrita" v-if="datoPago.monto === 0">
              El pago ya se realizó en su totalidad, no existe saldo pendiente.
            </p>
            <button
              type="submit"
              class="btn btn-light"
              @click.prevent="guardarPago"
              v-if="btnCrear"
              title="Guardar"
            >
              <i
                class="material-icons"
                style="font-size: 32px; color: blue; cursor: pointer"
                >save</i
              >Guardar
            </button>
            <button
              type="submit"
              class="btn btn-light"
              @click.prevent="actualizarPago"
              v-if="btnEditar"
              title="Actualizar"
            >
              <i
                class="material-icons"
                style="font-size: 32px; color: blue; cursor: pointer"
                >update</i
              >Actualizar
            </button>
            <button
              type="submit"
              class="btn btn-light"
              @click.prevent="actualizarPagoEstado"
              v-if="btnEditar"
            >
              Listo
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import config from '@/config';
import api from "@/services/api";
import { validarForm } from "@/modules/validacionesForms.js";
import dateFormat from "@/modules/dateFormat.js";
import { currentDate } from "@/modules/dateUtils";


import * as $ from "jquery";
window["$"] = $;
window["jQuery"] = $;
import swal from "sweetalert";
import swal2 from "sweetalert2";
export default {
  props: {
    p_idFactura: {
      type: Number,
      required: true,
    },
    p_estadoFactura: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      pagos: [],
      datoPago: {},
      nombreBusqueda: "",
      titulo: "",
      btnCrear: false,
      btnEditar: false,
      elementosPorPagina: 10,
      datosPaginados: [],
      paginaActual: 1,
      modalWindow: true,
      facturas: [],
      formaPagos: [],
      aseguradors: [],
      mostrarBloque: false,
      saldo: 0,
      showModalHelp: false,
      estiloImagen: {
        width: "200px",
        height: "200px",
      },
    };
  },
  computed: {
    totalPagos() {
      return this.datosPaginados.reduce((acc, pago) => acc + pago.monto, 0);
    },
  },
  mounted() {
    this.getDataPaginaTodos(this.paginaActual);
    this.fetchFormaPagos();
    this.fetchAseguradors();
  },
  methods: {
    mostrarOcultarBloque() {
      this.mostrarBloque = !this.mostrarBloque;
    },
    getFormattedDate(date) {
      return dateFormat.getFormattedDate(date);
    },
    totalPaginas() {
      return Math.ceil(this.pagos.length / this.elementosPorPagina);
    },
    getDataPaginaTodos(noPagina) {
      api.get("/vwpagos/idfactura/" + this.p_idFactura
        )
        .then((response) => {
          this.pagos = response.data.reverse();
          this.paginaActual = noPagina;
          this.datosPaginados = [];
          let ini =
            noPagina * this.elementosPorPagina - this.elementosPorPagina;
          let fin = noPagina * this.elementosPorPagina;
          this.datosPaginados = this.pagos.slice(ini, fin);
        });
    },
    getPreviousPage() {
      if (this.paginaActual > 1) {
        this.paginaActual--;
      }
      this.getDataPaginaTodos(this.paginaActual);
    },
    getNextPage() {
      if (this.paginaActual < this.totalPaginas()) {
        this.paginaActual++;
      }
      this.getDataPaginaTodos(this.paginaActual);
    },
    isActive(noPagina) {
      return noPagina == this.paginaActual ? "active" : "";
    },
    validarForm() {
      const requiredFields = ["idFormaPago", "monto"];
      const requiredFieldsText = ["idFormaPago", "monto"];
      return validarForm(this.datoPago, requiredFields, requiredFieldsText);
    },
    async guardarPago() {
      if (this.datoPago.monto > this.saldo) {
        swal("Error!", "El valor máximo es " + this.saldo, "error");
        return;
      }
      if (this.datoPago.monto < 0) {
        swal("Error!", "El valor no puede ser negativo.", "error");
        return;
      }
      if (this.validarForm() === 1) {
        try {
          this.datoPago.idEmpresa = window.sessionStorage.getItem("idEmpresa");
          this.datoPago.idUsuarioReg =
            window.sessionStorage.getItem("idUsuario");
          this.datoPago.idFactura = this.p_idFactura;
          await api.post("/pagos", this.datoPago);
          $("#ventanaModal").modal("hide");

          if (this.saldo - this.datoPago.monto === 0) {
            swal2
              .fire({
                title: "Pago Completado",
                text: "El pago ha sido creado y procesado exitosamente. No hay saldo pendiente.",
                icon: "success",
                confirmButtonText: "Aceptar",
              })
              .then(() => {
                console.log(
                  "El usuario ha sido notificado sobre el pago exitoso."
                );
              });
            //
            await api.post("/pagos",
              this.datoPago
            );
            //
          } else {
            swal2
              .fire({
                title: "Pago Creado con Saldo Pendiente",
                text: `El pago ha sido registrado, pero aún queda un saldo pendiente de ${
                  this.saldo - this.datoPago.monto
                }. ¿Deseas registrar otro pago ahora?`,
                icon: "warning",
                showCancelButton: true,
                confirmButtonText: "Registrar Otro Pago",
                cancelButtonText: "Más Tarde",
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33",
              })
              .then((result) => {
                if (result.isConfirmed) {
                  this.abrirModalCrear();
                } else {
                  swal2.fire({
                    title: "Pago Postergado",
                    text: "Puedes continuar creando pagos en cualquier momento desde la gestión de facturas.",
                    icon: "info",
                    confirmButtonText: "Aceptar",
                  });
                }
              });
          }
          this.getDataPaginaTodos(this.paginaActual);
        } catch (error) {
          swal2.fire({
            title: "Error en el Proceso",
            text: "Ha ocurrido un error al intentar procesar el pago. Por favor, intenta nuevamente.",
            icon: "error",
            confirmButtonText: "Reintentar",
          });
        }
      }
    },
    async actualizarPago() {
      if (this.datoPago.monto > this.saldo) {
        swal("Error!", "El valor máximo es " + this.saldo, "error");
        return;
      }

      if (this.validarForm() === 1) {
        try {
          this.datoPago.idUsuarioAct =
            window.sessionStorage.getItem("idUsuarioAct");
          await api.post("/pagos", this.datoPago);
          $("#ventanaModal").modal("hide");
          this.getDataPaginaTodos(this.paginaActual);
          swal("Correcto!", "Pago creado(a) exitosamente!", "success");
        } catch (error) {
          swal("Error!", "Intentelo de nuevo!", "error");
          var array = Object.values(error.response.data.errors);
          array.forEach((element) => swal(String(element)));
        }
      }
    },
    async actualizarPagoEstado() {
      if (this.validarForm() === 1) {
        this.datoPago.estadoPago = "PENDIENTE";
        try {
          await api.post("/pagos", this.datoPago);
          $("#ventanaModal").modal("hide");
          this.getDataPaginaTodos(this.paginaActual);
          swal("Correcto!", "Pago creado(a) exitosamente!", "success");
        } catch (error) {
          swal("Error!", "Intentelo de nuevo!", "error");
          var array = Object.values(error.response.data.errors);
          array.forEach((element) => swal(String(element)));
        }
      }
    },

    abrirModalCrear() {
      this.titulo = "Crear Pago";
      this.btnCrear = true;
      this.btnEditar = false;
      this.datoPago = { monto: this.saldo }; // Resetear datoPago y establecer el monto al saldo
      this.calcularDiferencia();
      this.datoPago.fechaPago = currentDate(new Date());

      // Ahora mostramos el modal
      $("#ventanaModal").modal("show");
    },

    /*     abrirModalCrear(){
      this.modalWindow = true
      this.datoPago={}
      this.titulo   = 'Crear Pago'
      this.btnCrear = true
      this.btnEditar= false
      this.calcularDiferencia()
    }, */
    abrirModalEditar(idPago) {
      this.modalWindow = true;
      if (idPago != null) {
        api.get("/vwpagos/" + idPago)
          .then((resp) => {
            this.datoPago = resp.data;
          });
      }
      $("#ventanaModal").modal("show");
      this.titulo = "Editar Pago";
      this.btnCrear = false;
      this.btnEditar = true;
    },
    abrirEditar(idPago) {
      if (idPago != null) {
        this.$router.push("/pagomd/" + idPago);
      }
    },
    async deletePago(idPago) {
      try {
        await api.delete("/pagos/" + idPago);
        this.getDataPaginaTodos(this.paginaActual);
      } catch (error) {
        alert("No se pudo eliminar");
      }
    },
    fetchFormaPagos() {
      fetch(config.apiBaseUrl + "/vwformapagos")
        .then((response) => response.json())
        .then((data) => {
          this.formaPagos = data;
        })
        .catch((error) => {
          console.error("Error fetching formaPagos:", error);
        });
    },
    fetchAseguradors() {
      fetch(config.apiBaseUrl + "/vwaseguradors")
        .then((response) => response.json())
        .then((data) => {
          this.aseguradors = data;
        })
        .catch((error) => {
          console.error("Error fetching aseguradors:", error);
        });
    },
    async calcularDiferencia() {
      try {
        // Obtener el valor total de la factura
        const valorTotalRespuesta = await api.delete(`/vwfacturadets/${this.p_idFactura}/valor-total`
        );
        const valorTotal = valorTotalRespuesta.data;

        // Obtener el total pagado de la factura
        const totalPagadoRespuesta = await api.delete(`/vwpagos/${this.p_idFactura}/total-pagado`
        );
        const totalPagado = totalPagadoRespuesta.data;

        // Calcular la diferencia
        const diferencia = valorTotal - totalPagado;

        // Actualizar el monto en datoPago
        this.saldo = diferencia;
        this.datoPago.monto = diferencia;
      } catch (error) {
        console.error("Error calculando la diferencia:", error);
        // Manejar el error adecuadamente
      }
    },
  },
};
</script>

<style scoped>
.texto-rojo-negrita {
  color: red;
  font-weight: bold;
}
</style>
